import { ControlIcon } from "@theprelude/ds";
import { Node, NodeProps } from "@xyflow/react";
import { ConnectedControlDataPoint } from "@/queries/control-monitor";
import { AggregateNode } from "./aggregate-node";

export type ConnectedControlNodeType = Node<
  ConnectedControlDataPoint,
  ConnectedControlDataPoint["type"]
>;

export const ConnectedControlNode = ({
  data,
}: NodeProps<ConnectedControlNodeType>) => (
  <AggregateNode
    data={data}
    description={data.instanceName}
    icon={<ControlIcon control={data.control} />}
    hasParent
  />
);
